import { render, staticRenderFns } from "./admConf.vue?vue&type=template&id=60b41a68"
import script from "./admConf.vue?vue&type=script&lang=js"
export * from "./admConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports